var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTot = function SvgTot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-70%",
    y: "-17.5%",
    width: "240%",
    height: "134.9%",
    filterUnits: "objectBoundingBox",
    id: "tot_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937344015 0 0 0 0 0.96111685 0 0 0 0 0.99973315 0 0 0 1 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-70%",
    y: "-6.8%",
    width: "240%",
    height: "113.5%",
    filterUnits: "objectBoundingBox",
    id: "tot_svg__c"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937344015 0 0 0 0 0.96111685 0 0 0 0 0.99973315 0 0 0 1 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-70%",
    y: "-8.2%",
    width: "240%",
    height: "116.4%",
    filterUnits: "objectBoundingBox",
    id: "tot_svg__e"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937344015 0 0 0 0 0.96111685 0 0 0 0 0.99973315 0 0 0 1 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-70%",
    y: "-7.8%",
    width: "240%",
    height: "115.6%",
    filterUnits: "objectBoundingBox",
    id: "tot_svg__g"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937344015 0 0 0 0 0.96111685 0 0 0 0 0.99973315 0 0 0 1 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-70%",
    y: "-6.2%",
    width: "240%",
    height: "112.3%",
    filterUnits: "objectBoundingBox",
    id: "tot_svg__i"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937344015 0 0 0 0 0.96111685 0 0 0 0 0.99973315 0 0 0 1 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-70%",
    y: "-7.8%",
    width: "240%",
    height: "115.7%",
    filterUnits: "objectBoundingBox",
    id: "tot_svg__k"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937344015 0 0 0 0 0.96111685 0 0 0 0 0.99973315 0 0 0 1 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "tot_svg__b",
    d: "M.093 48.652V31.467H4.38v17.185z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tot_svg__d",
    d: "M15.497 48.652V4.357h4.286v44.295z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tot_svg__f",
    d: "M30.155 48.652v-36.55h4.286v36.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tot_svg__h",
    d: "M45.807 48.652V10.166h4.286v38.486z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tot_svg__j",
    d: "M60.466 48.652V0h4.286v48.652z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tot_svg__l",
    d: "M75.621 48.652V10.408h4.286v38.244z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#tot_svg__a)",
    xlinkHref: "#tot_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.1,
    fill: "#37A3BC",
    xlinkHref: "#tot_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#tot_svg__c)",
    xlinkHref: "#tot_svg__d"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.1,
    fill: "#37A3BC",
    xlinkHref: "#tot_svg__d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#tot_svg__e)",
    xlinkHref: "#tot_svg__f"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.1,
    fill: "#37A3BC",
    xlinkHref: "#tot_svg__f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#tot_svg__g)",
    xlinkHref: "#tot_svg__h"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.1,
    fill: "#37A3BC",
    xlinkHref: "#tot_svg__h"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#tot_svg__i)",
    xlinkHref: "#tot_svg__j"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.1,
    fill: "#37A3BC",
    xlinkHref: "#tot_svg__j"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#tot_svg__k)",
    xlinkHref: "#tot_svg__l"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.1,
    fill: "#37A3BC",
    xlinkHref: "#tot_svg__l"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#40A9FF",
    fillOpacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.093 48.401V40.4H4.38v8.001zM15.497 48.401V12.274h4.286v36.127zM30.155 48.401v-30.55h4.286V48.4zM45.807 48.401V20.275h4.286v28.126zM60.466 48.401V5h4.286v43.401zM75.621 48.401V12.274h4.286v36.127z"
  })))));
};
export default SvgTot;